import React from 'react';
import Box from '@mui/material/Box';

// A small modern CSS spinner using conic-gradient for a sleek look
export default function ModernLoader({ size = 28 }: { size?: number }) {
  return (
    <Box sx={{ display: 'inline-block', width: size, height: size }}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          background: 'conic-gradient(#2563eb, #06b6d4, #60a5fa)',
          animation: 'spin 1s linear infinite',
          WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 6px), black calc(100% - 6px))',
        }}
      />
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
}
